module.exports = __webpack_public_path__ + "static/media/mastercard-logo.b8d5c7c6.svg";